import { render } from "./SettingsMessageTemplatesView.vue?vue&type=template&id=22fd7fff"
import script from "./SettingsMessageTemplatesView.vue?vue&type=script&lang=js"
export * from "./SettingsMessageTemplatesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__